export enum TransactionStatus {
    won = 'Won',
    running = 'Running',
    cancelled = 'Cancelled',
    declined = 'Declined',
    lost = 'Lost',
    approved = 'Approved',
    pending = 'Pending',
    credit = 'credit',
    deposit = 'deposit',
    withdraw = 'withdrawal_confirmation',
}

export enum TransactionType {
    deposit,
    withdrawal,
    manual,
    other,
}

export enum CancelStatus {
    success = 'success',
    failure = 'failure',
    pending = 'pending',
    none = 'none',
}

export default interface History {
    id: string;
    title: string;
    date: Date;
    amount: number;
    status: TransactionStatus;
    cancelStatus: CancelStatus;
    isWithdrawal: boolean;
    isCancelable: boolean;
    ticketId: string;
    type: TransactionType;
    method?: string;
    isFetchable: boolean;
    category: HistoryCategory;
    transactionType: TransactionType;
    gameName?: string;
    credit?: number;
    debit?: number;
    approved?: boolean;
    /* eslint-disable camelcase */
    bonus_balance?: number;
    cash_balance?: number;
    previous_bonus_balance?: number;
    previous_cash_balance?: number;
    source?: string;
    timestamp?: string;
    transaction_id?: string;
}

export enum HistoryPrintType {
    transaction = 'transaction',
    bonus = 'bonus',
}

export const HistoryCategory = {
    Transactions: 'Transactions',
    Bets: 'Bets',
    Casino: 'Casino',
    allTransactions: 'All Transactions',
} as const;
export type HistoryCategory = typeof HistoryCategory[keyof typeof HistoryCategory];
